import React from 'react';
import { connect } from 'react-redux'
import * as commonActionCreator from '../../../redux/actions/data-action';
import { Logo, Copyright, Version, SupportLink } from '../../common';
import { getLang } from './task-utility';
import { TaskProgress } from './task-controls'
import { isMobile } from 'react-device-detect';

class AssessmentFooter extends React.Component { 
    constructor(props) {
        super(props)

        this.getPercentCompleted = this.getPercentCompleted.bind(this);
    }

    getPercentCompleted() {
        const { screens, currentPath } = this.props;

        const currentIndex = screens.findIndex((screen) => {
            return screen.url === currentPath;
        })
        
        if (currentIndex > -1) {
            return (currentIndex / screens.length) * 100.00;
        } else {
            return 100.00;
        }
    }

    render() {
        const { label, includeVersion = false, includeProgress = true, style, copyrightChild, includeLogo = false, versionID } = this.props;
        const lang = getLang(versionID);
        return (
            <div className="assessment-footer">
                {includeVersion ? <Version/> : null}
                <Copyright children={copyrightChild} lang={lang} />
                {/* <SupportLink lang={lang}/> */}
                {includeLogo ? <Logo src={this.props.logo}/> : null}
            </div>
        )
    }
}

const mapStateToProps = (state, ownState) => ({
    logo: state.data.logoPath,
    screens : state.data.screens,
    currentPath: state.router.location.pathname,
    versionID: state.data.versionID
})

export default connect(mapStateToProps, commonActionCreator)(AssessmentFooter);